<template>
    <row class="relative" no-wrap>
        <column class="flex-1">
            <row :justify="innerWidth > 1422 ? 'space-between' : 'start'" align="stretch" :no-wrap="innerWidth > 1422">
                <!--                class="xs:mb-12 md:mt-10" lg="2/5" md="full" sm="full" xs="full"-->
                <column shrink>
                    <div class="text-left">
                        <divider class="mb-3" color="primary" width="56"></divider>
                        <div
                            class="poppins-bold text-secondary tracking-normal xs:leading-higher sm:leading-highest xs:text-3xl sm:text-5xl">
                            Customization
                        </div>
                        <div class="text-primary uppercase poppins-bold tracking-widest"
                        >Level Specific
                        </div>
                    </div>
                </column>
                <!--                lg="3/5" md="full" sm="full" xs="full"-->
                <column :class="innerWidth < 1422 ? 'w-full' : ''" align="center">
                    <template v-if="innerWidth < 1066">
                        <!--                     -translate-x-6, value must equal that of the outer container's padding in Home.vue   -->
                        <tw-carousel :options="options" class="w-screen transform -translate-x-6" ref="carousel" style="max-height: 412px; min-height: 412px;">
                            <column :key="itemIndex"
                                    class="px-5 pt-20 pb-6 flex-1 justify-center z-10"
                                    v-for="({src, title, subtitle}, itemIndex) of items"
                            >
                                <card class="flex flex-col justify-end items-center text-secondary relative"
                                      overflow="visible"
                                      no-padding
                                      style="min-width: 300px; max-width: 300px; min-height: 321px; max-height: 321px"
                                >
                                    <object :data="src" :id="'carouselObject_'+itemIndex"
                                            class="absolute"
                                            @load="animate(itemIndex)"
                                            style="min-width: 300px; max-width: 300px; max-height: 230px; min-height: 230px; top: -50px; pointer-events: none;"
                                            type="image/svg+xml"
                                    ></object>
                                    <div class="mb-10 flex flex-col items-center">
                                        <divider class="mb-5" color="primary" width="56"></divider>
                                        <div
                                            class="uppercase mt-4 w-full text-secondary text-center poppins-bold tracking-wide leading-tight"
                                            v-html="title"
                                        ></div>
                                        <div class="lowercase text-secondary text-center tracking-tight">{{subtitle}}</div>
                                    </div>
                                </card>
                            </column>
                        </tw-carousel>
                    </template>
                    <template v-else>
                        <row :class="innerWidth < 1422 ? 'pt-20' : 'pt-10'" align="stretch"
                             class="text-center -mx-4 z-10" no-wrap justify="center">
                            <column :key="itemIndex" align="center" class="xs:px-4 md:px-6"
                                    v-for="({src, title, subtitle}, itemIndex) of items"
                            >
                                <card class="flex flex-col justify-end items-center text-secondary relative"
                                      overflow="visible"
                                      style="min-width: 300px; max-width: 300px; min-height: 321px; max-height: 321px"
                                >
                                    <object :data="src" :id="'rowObject_'+itemIndex"
                                            class="absolute"
                                            @load="animate(itemIndex)"
                                            style="min-width: 300px; max-width: 300px; top: -50px;"
                                            type="image/svg+xml"
                                    ></object>
                                    <divider class="mb-5" color="primary" width="56"></divider>
                                    <div
                                        class="uppercase mt-4 w-full text-secondary text-center poppins-bold tracking-wide leading-tight"
                                        v-html="title"
                                    ></div>
                                    <div class="lowercase text-secondary text-center tracking-tight">{{subtitle}}</div>
                                </card>
                            </column>
                        </row>
                    </template>
                </column>
            </row>
            <row align="center" class="xs:mt-24 sm:mt-32">
<!--                md="3/5" sm="full"-->
                <column xs="full" class="pr-20 py-6">
                    <row :no-wrap="vertical" align="stretch"
                         class="tracking-normal leading-tight xs:text-2xl sm:text-xl">
                        <column class="text-white" xs="full">
                            <div>Organizational</div>
                            <div>Talent Frameworks</div>
                        </column>
                        <column align="center" class="sm:px-20" justify="center" shrink xs="full">
                            <divider :class="vertical ? '' : 'my-10'"
                                     :height="vertical ? 38 : 2"
                                     :vertical="vertical"
                            ></divider>
                        </column>
                        <column class="text-white" xs="full">
                            <div>Organization</div>
                            <div>Specific Components</div>
                        </column>
                        <column align="center" class="sm:px-20" justify="center" shrink xs="full">
                            <divider :class="vertical ? '' : 'my-10'"
                                     :height="vertical ? 38 : 2"
                                     :vertical="vertical"
                            ></divider>
                        </column>
                        <column class="text-white" xs="full">
                            <div>Organizational Interface</div>
                            <div>and branding</div>
                        </column>
                    </row>
                </column>
                <!--                sm="full"-->
                <column class="xs:pt-8 flex-shrink" xs="full">
                    <div :class="!vertical ? 'mt-4' : ''"
                         class="uppercase text-accent poppins-bold tracking-widest xs:text-2xl sm:text-xl"
                    >Tailored to need
                    </div>
                </column>
            </row>
        </column>
    </row>
</template>

<script>
    import anime from 'animejs';
    import Helpers from "../../mixins/Helpers";

    export default {
        name: "Customization",
        mixins: [Helpers],
        props: {},
        components: {
            divider: () => import('@/components/Divider.vue'),
            row: () => import('@/components/display/Row.vue'),
            column: () => import('@/components/display/Col.vue'),
            card: () => import('@/components/Card.vue'),
            'tw-carousel': () => import('@/components/TwCarousel.vue')

        },
        computed: {
            vertical() {
                return innerWidth >= parseInt(this.$theme.screens.lg.min.replace('px', ''));
            }
        },
        data: () => ({
            items: [
                {
                    src: require('@/assets/images/components/professional_operational.svg'),
                    title: 'Professional',
                    subtitle: 'Operational',
                },
                {
                    src: require('@/assets/images/components/managerial_tactical.svg'),
                    title: 'Managerial',
                    subtitle: 'Tactical',
                },
                {
                    src: require('@/assets/images/components/executive_strategic.svg'),
                    title: 'Executive',
                    subtitle: 'Strategic',
                }
            ],
            innerWidth: 0,
            options: {
                pageDots: false
            }
        }),
        methods: {
            setInnerWidth(render = true) {
                this.innerWidth = window.innerWidth;
                this.options.pageDots = this.innerWidth < 975;
                if(render && this.innerWidth < 1066) {
                    this.$nextTick(() => {
                        this.$refs.carousel.reRender();
                    });
                }
            },
            getElement(item, id) {
                return item.contentDocument.querySelector(id);
            },
            setInitialPosition(target, x, y) {
                anime.set(target, {translateX: x, translateY: y});
            },
            initAnimations() {
                this.items.forEach((item, index) => {
                    let main = this.$el.querySelector('#carouselObject_' + index) || this.$el.querySelector('#rowObject_' + index);
                    if (index === 0) {
                        let gear_1 = this.getElement(main, '#Group_250'),
                            gear_2 = this.getElement(main, '#Group_252');
                        this.setInitialPosition(gear_1, 82.952, 0);
                        this.setInitialPosition(gear_2, 0, 58.815);
                        this.animateGear(gear_1, 360, 60000);
                        this.animateGear(gear_2, -360, 30000);
                    } else if (index === 1) {
                        let ball = this.getElement(main, '#Like'),
                            hand = this.getElement(main, '#Group_241');
                        this.setInitialPosition(ball, 210.527, 113.714);
                        this.setInitialPosition(hand, 11.027, 10.591);
                        this.animateBall(ball, hand, 1000, 700, 700);
                    } else {
                        let stick = this.getElement(main, '#Path_780');
                        this.setInitialPosition(stick, -116.797, -141.602);
                        this.animateStick(stick, 10, 1000);
                    }
                });
            },
            animateGear(target, degrees, duration) {
                anime.set(target, {transformOrigin: '50% 50%', transformBox: 'fill-box'});
                anime({
                    targets: target,
                    rotate: degrees,
                    duration: duration,
                    easing: 'linear',
                    loop: true
                });
            },
            animateBall(ball, hand, ballDuration, handDuration, handDelay) {
                anime({
                    targets: ball,
                    keyframes: [
                        {translateY: 100},
                        {translateY: 113.714}
                    ],
                    duration: ballDuration,
                    // direction: 'alternate',
                    easing: 'cubicBezier(0.175, 0.885, 0.32, 1.275)',
                    // easing: 'easeInOutExpo',
                    loop: true
                });
                anime.set(hand, {transformOrigin: '50% 50%', transformBox: 'fill-box'});
                anime({
                    targets: hand,
                    keyframes: [
                        {translateX: [11.027, 24], rotateY: -90, duration: handDuration},
                        {rotateY: 90, duration: 0},
                        {translateX: [-2, 11.027], rotateY: 0, duration: handDuration, delay: handDelay}
                    ],
                    easing: 'linear',
                    loop: true
                });
            },
            animateStick(stick, rotation, duration) {
                anime.set(stick, {transformOrigin: '20% 100%', transformBox: 'fill-box'});
                anime({
                    targets: stick,
                    rotate: rotation,
                    duration: duration,
                    direction: 'alternate',
                    easing: 'easeInCubic',
                    loop: true
                });
            },
            animate(index) {
                if(index === 2) {
                    this.initAnimations();
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
            this.setInnerWidth(false);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>

</style>